import { validationMessage } from 'vuelidate-messages'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import { messages } from '@/lib/validation-helpers'

export const validations = {
  validations() {
    const validations = {
      payload: {
        name: { required },
        role_id: { required },
        email: {
          required,
          email
        }
      }
    }

    if (this.modalType === 'create') {
      validations.payload.password = {
        required,
        minLength: minLength(8)
      }
      validations.payload.password_confirmation = {
        sameAs: sameAs('password')
      }
    }

    return validations
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass() {
      this.$v.$touch()
      return !this.$v.$invalid
    }
  }
}
